import { authService } from '@/services/authnService.js'
import {
  deleteResource,
  fetchResource,
  postResource,
  putResource
} from '@/services/fetchService.js'

class PushService {
  constructor() {
    this.type = ''
  }

  fetchKey = async () => {
    const { vapidPublicKey } = await fetchResource('/push/key')
    return { vapidPublicKey }
  }

  saveSubscription = async (subscription) => {
    const userId = authService.getUserId()
    const augmentedSubscription = {
      ...subscription,
      origin: window.location.hostname,
      userId: userId
    }

    const response = await postResource('push/subscription', augmentedSubscription)
    return response
  }

  deleteSubscription = async (subscriptionId) => {
    const response = await deleteResource(`push/subscription/${subscriptionId}`)
    return response
  }

  updateSubscription = async (subscription) => {
    const subscriptionId = subscription.id
    const response = await putResource(`push/subscription/${subscriptionId}`, subscription)
    return response
  }
}

export default PushService
export const pushService = new PushService()
